<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr class="cursor-pointer" (click)="setActiveContract(item)">
      <td>{{ item.title || '---' }}</td>

      <td>
        <div class="flex flex-col align-start justify-start gap-1">
          @for (people of item.people; track people.id) {
            <div>{{ people.name }}</div>
          }
        </div>
      </td>

      <td>{{ item?.start_date | date: 'dd/MM/y' }}</td>

      <td>
        <div class="flex flex-wrap gap-2">
          @for (tag of item?.tags; track $index) {
            <p-tag [style]="{ background: tag.bg_color }">
              <div [style]="{ color: tag.text_color }">{{ tag.name }}</div>
            </p-tag>
          }
        </div>
      </td>

      <td>
        {{ item?.due_date | date: 'dd/MM/y' }}<br>
        <div
          [ngClass]="{
            'text-rose-600': isExpired(item?.due_date)
          }"
        >
          {{ isExpired(item?.due_date) ? 'Finalizado' : dueDateDiffInMonths(item?.due_date) + ' meses' }}
        </div>
      </td>

      <td>
        <div
          [ngClass]="{
            'text-emerald-600': item?.status === contractStatus.ACTIVE,
            'text-zinc-300': item?.status === contractStatus.TERMINATED,
            'text-rose-600': item?.status === contractStatus.COMPLETED
          }"
        >
          {{ item?.status | contractStatus }}
        </div>
      </td>

      <td>
        <div class="w-fit py-0 px-1 flex items-center justify-center gap-1 border border-zinc-300 bg-zinc-100 rounded">
          <i class="fa-solid fa-file-invoice"></i>
          {{ item?.docs.length }}
        </div>
      </td>

      <td>
          <div
            class="cursor-pointer"
            pTooltip="Visualizar"
            tooltipPosition="bottom"
            (click)="view.emit(item); $event.stopPropagation()"
          >
            <i class="fa-regular fa-eye"></i>
          </div>
      </td>
    </tr>

    <tr>
      <td class="border-none" colspan="8">
        <p-accordion [(value)]="activeContract">
          <p-accordion-panel class="border-none" [value]="item.id">
            <p-accordion-content>
              <ng-container
                [ngTemplateOutlet]="subTableContract"
                [ngTemplateOutletContext]="{ contract: item }"
              ></ng-container>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </td>
    </tr>
  </ng-template>
 <ng-template #footer>
   <tr>
     <td colspan="8">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
     </td>
   </tr>
 </ng-template>
</p-table>

<ng-template #subTableContract let-contract="contract">
  <p-table
    [value]="[contract]"
    [loading]="localLoading()"
  >
    <ng-template #header>
      <tr>
        <th class="text-sm">Descrição</th>
        <th class="text-sm">Tipo de Pagamento</th>
        <th class="text-sm">Valor do Contrato</th>
        <th class="text-sm">Vencimento</th>
        <th class="text-sm">Arquivos</th>
      </tr>
    </ng-template>
    <ng-template #body let-item>
      <tr>
        <td>{{ item.description || '---' }}</td>

        <td>{{ item.payment_type | contractPaymentType }}</td>

        <td>{{ item.value | currency }}</td>

        <td>{{ item.due_date | date: 'dd/MM/y' }}</td>

        <td>
          <div class="flex flex-col items-start justify-start gap-2">
            @for (doc of item.docs; track $index) {
              <div
                class="w-fit text-sm py-0 px-1 flex items-center justify-center gap-1 border border-zinc-300 bg-zinc-100 rounded cursor-pointer hover:bg-zinc-50"
                (click)="openFile(doc.doc); $event.stopPropagation()"
              >
                <i class="fa-solid fa-file-invoice"></i>
                {{ doc.description }}
              </div>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
